const statesUrlData = {
	'New York': {
		lt: '40.7127753',
		lg: '-74.0059728',
		ct: 'New York',
		st: 'NY',
		encodedOverride: '',
	},
	'New Jersey': {
		lt: '40.0583238',
		lg: '-74.4056612',
		ct: 'New Jersey, USA',
		st: 'NJ',
		encodedOverride: '',
	},
	Connecticut: {
		lt: '41.6032207',
		lg: '-73.087749',
		ct: 'Connecticut, USA',
		st: 'CT',
		encodedOverride: '',
	},
	Massachusetts: {
		lt: '42.3600825',
		lg: '-71.0588801',
		ct: 'Boston',
		st: 'MA',
		encodedOverride: '',
	},
	Florida: {
		lt: '30.4382559',
		lg: '-84.28073289999999',
		ct: 'Tallahassee',
		st: 'FL',
		encodedOverride: '',
	},
	Arizona: {
		encodedOverride:
			'&lt=MzQuMDQ4OTI4MQ==&lg=LTExMS4wOTM3MzEx&ct=QXJpem9uYSUyQyUyMFVTQQ==&st=QVo=',
	},
	Texas: {
		encodedOverride:
			'&lt=MzEuOTY4NTk4OA==&lg=LTk5LjkwMTgxMzE=&ct=VGV4YXMlMkMlMjBVU0E=&st=VFg=',
	},
	Nevada: {
		encodedOverride:
			'&lt=MzguODAyNjA5Nw==&lg=LTExNi40MTkzODk=&ct=TmV2YWRhJTJDJTIwVVNB&st=TlY=',
	},
	Alabama: {
		encodedOverride:
			'&lt=MzIuMzE4MjMxNA==&lg=LTg2LjkwMjI5OA==&ct=QWxhYmFtYSUyQyUyMFVTQQ==&st=QUw=',
	},
	Colorado: {
		encodedOverride:
			'&lt=MzkuNTUwMDUwNw==&lg=LTEwNS43ODIwNjc0&ct=Q29sb3JhZG8lMkMlMjBVU0E=&st=Q08=',
	},
	Iowa: {
		encodedOverride:
			'&lt=NDEuODc4MDAyNQ==&lg=LTkzLjA5NzcwMg==&ct=SW93YSUyQyUyMFVTQQ==&st=SUE=',
	},
	'North Carolina': {
		encodedOverride:
			'&lt=MzUuNzU5NTczMQ==&lg=LTc5LjAxOTI5OTY5OTk5OTk5&ct=Tm9ydGglMjBDYXJvbGluYSUyQyUyMFVTQQ==&st=TkM=',
	},
	'New Hampshire': {
		encodedOverride:
			'&lt=NDMuMTkzODUxNg==&lg=LTcxLjU3MjM5NTM=&ct=TmV3JTIwSGFtcHNoaXJlJTJDJTIwVVNB&st=Tkg=',
	},
	Ohio: {
		encodedOverride:
			'&lt=NDAuNDE3Mjg3MQ==&lg=LTgyLjkwNzEyMzAwMDAwMDAx&ct=T2hpbyUyQyUyMFVTQQ==&st=T0g=',
	},
	Pennsylvania: {
		encodedOverride:
			'&lt=NDEuMjAzMzIxNg==&lg=LTc3LjE5NDUyNDc=&ct=UGVubnN5bHZhbmlhJTJDJTIwVVNB&st=UEE=',
	},
	Alaska: {
		encodedOverride:
			'&lt=NjQuMjAwODQxMw==&lg=LTE0OS40OTM2NzMz&ct=QWxhc2thJTJDJTIwVVNB&st=QUs=',
	},
	California: {
		encodedOverride:
			'&lt=MzYuNzc4MjYx&lg=LTExOS40MTc5MzI0&ct=Q2FsaWZvcm5pYSUyQyUyMFVTQQ==&st=Q0E=',
	},
	Delaware: {
		encodedOverride:
			'&lt=MzguOTEwODMyNQ==&lg=LTc1LjUyNzY2OTg5OTk5OTk5&ct=RGVsYXdhcmUlMkMlMjBVU0E=&st=REU=',
	},
	'District Of Columbia': {
		encodedOverride:
			'&lt=MzguOTA1OTg0OQ==&lg=LTc3LjAzMzQxNzkwMDAwMDAy&ct=V2FzaGluZ3Rvbg==&st=REM=',
	},
	Georgia: {
		encodedOverride:
			'&lt=MzIuMTY1NjIyMQ==&lg=LTgyLjkwMDA3NTE=&ct=R2VvcmdpYSUyQyUyMFVTQQ==&st=R0E=',
	},
	Illinois: {
		encodedOverride:
			'&lt=NDAuNjMzMTI0OQ==&lg=LTg5LjM5ODUyODM=&ct=SWxsaW5vaXMlMkMlMjBVU0E=&st=SUw=',
	},
	Indiana: {
		encodedOverride:
			'&lt=NDAuMjY3MTk0MQ==&lg=LTg2LjEzNDkwMTk=&ct=SW5kaWFuYSUyQyUyMFVTQQ==&st=SU4=',
	},
	Kansas: {
		encodedOverride:
			'&lt=MzkuMDExOTAy&lg=LTk4LjQ4NDI0NjU=&ct=S2Fuc2FzJTJDJTIwVVNB&st=S1M=',
	},
	Kentucky: {
		encodedOverride:
			'&lt=MzcuODM5MzMzMg==&lg=LTg0LjI3MDAxNzk=&ct=S2VudHVja3klMkMlMjBVU0E=&st=S1k=',
	},
	Louisiana: {
		encodedOverride:
			'&lt=MzAuOTg0Mjk3Nw==&lg=LTkxLjk2MjMzMjY5OTk5OTk5&ct=TG91aXNpYW5hJTJDJTIwVVNB&st=TEE=',
	},
	Maine: {
		encodedOverride:
			'&lt=NDUuMjUzNzgz&lg=LTY5LjQ0NTQ2ODk=&ct=TWFpbmUlMkMlMjBVU0E=&st=TUU=',
	},
	Maryland: {
		encodedOverride:
			'&lt=MzkuMDQ1NzU0OQ==&lg=LTc2LjY0MTI3MTE5OTk5OTk5&ct=TWFyeWxhbmQlMkMlMjBVU0E=&st=TUQ=',
	},
	Michigan: {
		encodedOverride:
			'&lt=NDQuMzE0ODQ0Mw==&lg=LTg1LjYwMjM2NDI5OTk5OTk5&ct=TWljaGlnYW4lMkMlMjBVU0E=&st=TUk=',
	},
	Minnesota: {
		encodedOverride:
			'&lt=NDYuNzI5NTUz&lg=LTk0LjY4NTg5OTg=&ct=TWlubmVzb3RhJTJDJTIwVVNB&st=TU4=',
	},
	Missouri: {
		encodedOverride:
			'&lt=MzcuOTY0MjUyOQ==&lg=LTkxLjgzMTgzMzQ=&ct=TWlzc291cmklMkMlMjBVU0E=&st=TU8=',
	},
	Montana: {
		encodedOverride:
			'&lt=NDYuODc5NjgyMg==&lg=LTExMC4zNjI1NjU4&ct=TW9udGFuYSUyQyUyMFVTQQ==&st=TVQ=',
	},
	Nebraska: {
		encodedOverride:
			'&lt=NDEuNDkyNTM3NA==&lg=LTk5LjkwMTgxMzE=&ct=TmVicmFza2ElMkMlMjBVU0E=&st=TkU=',
	},
	'New Mexico': {
		encodedOverride:
			'&lt=MzQuNTE5OTQwMg==&lg=LTEwNS44NzAwOTAx&ct=TmV3JTIwTWV4aWNvJTJDJTIwVVNB&st=Tk0=',
	},
	Oklahoma: {
		encodedOverride:
			'&lt=MzUuMDA3NzUxOQ==&lg=LTk3LjA5Mjg3Nw==&ct=T2tsYWhvbWElMkMlMjBVU0E=&st=T0s=',
	},
	Oregon: {
		encodedOverride:
			'&lt=NDMuODA0MTMzNA==&lg=LTEyMC41NTQyMDEy&ct=T3JlZ29uJTJDJTIwVVNB&st=T1I=',
	},
	'Rhode Island': {
		encodedOverride:
			'&lt=NDEuNTgwMDk0NQ==&lg=LTcxLjQ3NzQyOTE=&ct=UmhvZGUlMjBJc2xhbmQlMkMlMjBVU0E=&st=Ukk=',
	},
	'South Carolina': {
		encodedOverride:
			'&lt=MzMuODM2MDgx&lg=LTgxLjE2MzcyNDU=&ct=U291dGglMjBDYXJvbGluYSUyQyUyMFVTQQ==&st=U0M=',
	},
	'South Dakota': {
		encodedOverride:
			'&lt=NDMuOTY5NTE0OA==&lg=LTk5LjkwMTgxMzE=&ct=U291dGglMjBEYWtvdGElMkMlMjBVU0E=&st=U0Q=',
	},
	Tennessee: {
		encodedOverride:
			'&lt=MzUuNTE3NDkxMw==&lg=LTg2LjU4MDQ0NzM=&ct=VGVubmVzc2VlJTJDJTIwVVNB&st=VE4=',
	},
	Utah: {
		encodedOverride:
			'&lt=MzkuMzIwOTgwMQ==&lg=LTExMS4wOTM3MzEx&ct=VXRhaCUyQyUyMFVTQQ==&st=VVQ=',
	},
	Vermont: {
		encodedOverride:
			'&lt=NDQuNTU4ODAyOA==&lg=LTcyLjU3Nzg0MTQ5OTk5OTk5&ct=VmVybW9udCUyQyUyMFVTQQ==&st=VlQ=',
	},
	Virginia: {
		encodedOverride:
			'&lt=MzcuNDMxNTczNA==&lg=LTc4LjY1Njg5NDI=&ct=VmlyZ2luaWElMkMlMjBVU0E=&st=VkE=',
	},
	Washington: {
		encodedOverride:
			'&lt=NDcuNzUxMDc0MQ==&lg=LTEyMC43NDAxMzg2&ct=V2FzaGluZ3RvbiUyQyUyMFVTQQ==&st=V0E=',
	},
	'West Virginia': {
		encodedOverride:
			'&lt=MzguNTk3NjI2Mg==&lg=LTgwLjQ1NDkwMjY=&ct=V2VzdCUyMFZpcmdpbmlhJTJDJTIwVVNB&st=V1Y=',
	},
	Wisconsin: {
		encodedOverride:
			'&lt=NDMuNzg0NDM5Nw==&lg=LTg4Ljc4Nzg2Nzg=&ct=V2lzY29uc2luJTJDJTIwVVNB&st=V0k=',
	},
	Wyoming: {
		encodedOverride:
			'&lt=NDMuMDc1OTY3OA==&lg=LTEwNy4yOTAyODM5&ct=V3lvbWluZyUyQyUyMFVTQQ==&st=V1k=',
	},
};

export const handleDirectoryRedirect = async (state, services = []) => {
	const directory = btoa(encodeURIComponent('teletherapy_preference_online'));
	let locationQuery;
	let serviceQuery;
	if (statesUrlData[state]) {
		const { lt, lg, ct, st, encodedOverride } = statesUrlData[state];
		locationQuery = encodedOverride
			? `${directory}${encodedOverride}`
			: `${directory}&lt=${btoa(lt)}&lg=${btoa(lg)}&ct=${btoa(ct)}&st=${btoa(st)}`;
	} else locationQuery = '';

	serviceQuery = btoa(encodeURIComponent(services.join('')));
	const newUrl = `https://secure.helloalma.com/providers-results/?filterables=${serviceQuery}${
		serviceQuery ? '&' + locationQuery : locationQuery
	}`;
	window.location.href = newUrl;
};
